import {getGridData, copy, sync, getDicData, getTreeData,getSqlDicData } from '@/api/form-render'
import Vue from 'vue'
import excel from '@/utils/excel'
// import {formUtil} from '../form'

export const mixin = {
  data: function () {
    return {
      dicData: {},
      rowSpanData:{}, // 合并行的数据
      rowSpanColumns:[],
      gridColumns: [],
      moreColumns: [],
      gridData: [],
      pageSize: 30,
      pageIndex: 1,
      pageCount: 0,
      totalCount: 0,
      insertCount: 0,
      updateCount: 0,
      errorCount: 0,
      errorData: [],
      codeColumnNames:[], // 单号字段
      resultVisible: false,
      parentSelectedRow: null, // 级联页面，父页面的选中行
      flag: true, // 判断是否有配置流程状态字段
      openDialogWidth: '',
      openDialogHeight: '',
      openConfig: {},
      rootId: null,
      selectExcelVisible: false,
      excelList: [],
      excelData: [],
      excelModal: null,
      uploadConfig: {
        limit: 10,
        limitSize: 50048576,
        // listType: 'picture-card',
        readOnly: false,
        xtype: 'test',
        accept: '.xlsx,.xls',
        acceptMsg: '只能传xls/xlsx格式文件'
      },
      searchPlaceholder: '请输入关键字'
    }
  },
  props: {

  },
  computed: {
    switchVal () {
      return true
    }
  },
  activated(){

    // console.log('---------form-tree-table-------activated------',this.$route.path);
  },
  mounted () {
    // console.log('---------form-tree-table-------mounted------',this.$route.path);
    this.keyword = ''
    this.formData = {}
    this.gridData = []
    this.pageSize = 30
    this.pageCount = 0
    this.pageIndex = 1
    this.totalCount = 0
    this.queryFormVisible = false
    this.searchFormRows = []
    this.searchFormColumns = []
    this.topButtons = []
    this.showPageBar = false
    this.rowSpanData = {}
    this.editButtonColumn = null;
    this.rowSpanColumns = []
    this.codeColumnNames = [];
    this.disabledConditionData = {}
    this.summaryColumns = {}
    this.init()
  },
  methods: {
    init () {
      // console.log('table表格字段信息queryConfig: ', this.config.queryColumns)
      let _this = this
      let gridColumns = []
      let searchFormColumns = []
      let searchFormRows = []
      let searchVisible = false
      let searchPlaceholder = []
      let queryColumns = this.config.queryColumns
      let ifNewBtn = false
      let ifImportBtn = false
      let ifExportBtn = false
      let summaryColumns = null
      let topButtons = []
      let formData = {}

      this.columnTitleMap = {}
      this.columnsMap = {}
      let code = []
      if (this.config.pageSize !== undefined && this.config.pageSize === 0) {
        this.showPageBar = false
      } else {
        this.showPageBar = true
      }
      if (this.config.pageSize) this.pageSize = this.config.pageSize
      let formConfig = {}
      if (this.config.parent && this.config.parent.formConfig) {
        formConfig = this.config.parent.formConfig
        // formCode单号
        if (formConfig.formCode) {
          code.push(formConfig.formCode.field);
        }
        if (formConfig.formCodes) {
          formConfig.formCodes.forEach(item=>{
            code.push(item.field);
          });
        }
      }
      this.codeColumnNames = code;
      if (queryColumns) {
        // 遍历每个表单中配置的查询列
        queryColumns.forEach((column,index) => {
          if (column.columnName && code.indexOf(column.columnName)>-1) {
            if (!column.openParams && !column.openUrl) {
              let params = {'formKey': this.config.formKey, 'businessKey': '{ID_}', 'disabled': true,formInfoId:this.config.id}
              column.openParams = JSON.stringify(params)
              column.openUrl = 'form-edit'
              column.openType = 1
            }
          }

          column.index = index

          if(column.rowSpan){
          // if(index == 1 || index == 4){
            this.rowSpanColumns.push(column)
          }

          if(column.columnName && column.title){
            _this.columnTitleMap[column.title] = column.columnName
            _this.columnsMap[column.columnName] = column
          }

          if (column.matchType && column.row && column.col) {
            if (searchFormRows[column.row - 1] === undefined) {
              searchFormRows[column.row - 1] = []
            }
            searchFormRows[column.row - 1].push(column)
            searchFormColumns.push(column)
            // 判断是否携带默认搜索条件
            // 判断是否是固定常量
            if (column.sourceType === 'const') {
              formData[column.columnName] = column.sourceAttr
            } else if (column.sourceType === 'sys-conf') { // 判断如果是系统常量
              formData[column.columnName] = this.getConstValue(column.sourceAttr)
              // 如果项目ID 并且类型为弹框选择 给查询条件添加默认值
              if (column.widgetType === 'select-form' && (column.sourceAttr === '{session-proj-uid}' || column.sourceAttr === '{session-proj-id}')) {
                formData[column.columnName + 'LABEL_'] = this.getConstValue('{session-proj-name}')
              }
            }else{
              // 判断是否客户没有选择设置高级查询条件值
                 // 判断如果组件传参queryParams有值，则替换
                let val = this.queryParams && this.queryParams[column.columnName]
                if(this.validUtil.isNotNull(val)){
                  formData[column.columnName] = val
                }
            }
          } // 如果是数表则配置有模糊查询
          if (column.matchType === 'like' && this.isTree && column.hidden !== 1) {
            searchPlaceholder.push(column.title)
            searchVisible = true
          }
          // 如果列表则配置过匹配类型就显示搜索框 并且不配置行列 并且匹配类型配置未like
          if (column.matchType && !this.isTree && column.hidden !== 1 && !column.row && !column.col && column.matchType === 'like') {
            searchPlaceholder.push(column.title)
            searchVisible = true
          }
          if (column.widgetType === 'select' || column.widgetType === 'switch') {
            let attr = column.attr
            column['options'] = []
            // 加载数据字典
            if (_this.validUtil.isNotNull(attr)) {
              if (attr.indexOf(',') > -1) {
                _this.dicMap[column.columnName] = {}
                // 说明是直接写死类型
                let data = {}
                let dataArr = []
                let options = attr.split(';')
                options.forEach(item => {
                  let option = item.split(',')
                  let name = option[1];
                  let value = column.javaType === 'Integer' ? parseInt(option[1]) : option[1];
                  _this.dicMap[column.columnName][column.javaType === 'Integer' ? parseInt(option[0]) : option[0]] = option[1]
                  // 存入键值对
                  data[column.javaType === 'Integer' ? parseInt(option[0]) : option[0]] = option[1];
                  dataArr.push({name: name, value: value});
                })
                column.options = data;
                column.optionsArr = dataArr;
                //console.log("==============",column.options,column.optionsArr);
              }
            }
          } else if (column.widgetType === 'select-dic') {
            let attr = column.attr
            getDicData(attr).then(dicData => {
              let data = {}
              let dataArr = []
              if (dicData) {
                _this.dicMap[column.columnName] = {}
                dicData.forEach(item => {
                  // 存入键值对
                  data[item.value] = item.name
                  _this.dicMap[column.columnName][item.value] = item['name']
                  let name = item.name;
                  let value = item.value;
                  dataArr.push({name: name, value: value});
                })
                // _this.dicData[column.attr] = data;
              }
              this.$set(column, 'options', data)
              this.$set(column, 'optionsArr', dataArr)
              //console.log("========2======",column.options,column.optionsArr);
              // _this.$refs['jr-table'].doLayout();
              this.$forceUpdate()
            })
          }  else if (column.widgetType === 'select-sql') {
            let attr = column.attr
            // 加载数据字典
            if (_this.validUtil.isNotNull(attr)) {
              getSqlDicData({formKey: this.formKey, columnId: column.id}).then(dicData => {
                // console.log('-----dicData----',dicData)
                let data = {}
                if(dicData){
                  _this.dicMap[column.columnName] = {}
                  dicData.forEach(item => {
                    // 存入键值对
                    data[item.value] = item.name
                    _this.dicMap[column.columnName][item.value] = item['name']
                  })
                  // console.log('------data-----',data)
                }

                this.$set(column, 'options', data)
                // _this.$refs['jr-table'].doLayout();
                this.$forceUpdate()
              })
            }
          }else if (column.widgetType === 'tag') {
            let attr = column.attr
            if (_this.validUtil.isNotNull(attr)) {
              // 先判断是否市json
              try {
                let strObj = JSON.parse(attr)
                let params = strObj.params
                if (params.indexOf(',') > -1) {
                  let data = {}
                  let options = params.split(';')
                  options.forEach(item => {
                    let option = item.split(',')
                    // 存入键值对
                    data[option[0]] = 'jr-tag-' + option[1]
                  })
                  column.tabMap = data
                  // console.info(data)
                }
              } catch (error) {
                if (attr.indexOf(',') > -1) {
                  let data = {}
                  let options = attr.split(';')
                  options.forEach(item => {
                    let option = item.split(',')
                    // 存入键值对
                    data[option[0]] = 'jr-tag-' + option[1]
                  })
                  column.tabMap = data
                  // console.info(data)
                }
              }
            }
          }else if (column.widgetType === 'custom-font') {
            let attr = column.attr
            if (_this.validUtil.isNotNull(attr)) {
              // 先判断是否市json
              try {
                let strObj = JSON.parse(attr)
                column.customMap = strObj
              } catch (error) {
                column.customMap = {}
              }
            }
          }
          if (column.widgetType === 'pic-view') {
            let attr = column.attr
            // 加载数据字典
            if (_this.validUtil.isNotNull(attr)) {
              let attrObj = JSON.parse(attr)
              column.width = attrObj.width ? ((attrObj.width + '').indexOf('px') > -1 ? attrObj.width : (attrObj.width + 'px')) : '100px'
              column.height = attrObj.height ? ((attrObj.height + '').indexOf('px') > -1 ? attrObj.height : (attrObj.height + 'px')) : '100px'
              column.ifThumb = column.ifThumb ? column.ifThumb : true
            }
          }
          if (column && column.javaType === 'TopButton') {
            if (column.columnName.toLowerCase() === 'new' && this.config.btnAdd == 1 && !this.readOnly && (!this.singleSelect && !this.multipleSelect)) {
              ifNewBtn = true
              topButtons.push(column)
            }else if (column.columnName.toLowerCase() === 'import' && !this.readOnly && (!this.singleSelect && !this.multipleSelect)) {
              ifImportBtn = true
              topButtons.push(column)
            } else if (column.columnName.toLowerCase() === 'export' && !this.readOnly && this.config.btnExport == 1 && (!this.singleSelect && !this.multipleSelect)) {
              ifExportBtn = true
              topButtons.push(column)
            } else {
              topButtons.push(column)
            }
          } else if (column && column.javaType === 'CellButton') {
            if (column.columnName.toLowerCase() === 'edit' || column.columnName.toLowerCase() === 'delete') {
              if (column.columnName.toLowerCase() === 'edit') {
                if(column.hidden === 1){
                  this.showRowEditButton = false;
                }else{
                  // 说明是自定义编辑按钮
                  this.editButtonColumn = column;
                }

              }
              if (column.columnName.toLowerCase() === 'delete' && column.hidden === 1) {
                this.showRowDeleteButton = false
              }
            } else {
              gridColumns.push(column)
            }
          } else {
            gridColumns.push(column)
          }

          if (column.summary) {
            if (summaryColumns === null) {
              summaryColumns = {}
            }
            summaryColumns[column.columnName] = column
          }
        })
        // 计算每个控件占每行的比例
        if (searchFormRows) {
          // searchFormRows.filter(e => {
          //   let col = 0;
          //   e.forEach(v => {col += v.col;});
          //   e.filter(v => {v.col = v.col / col;return v});
          //   return e
          // });
          // 修改每个控件占每行的比例
          // 修改每个控件占每行的比例
          searchFormRows = searchFormRows.map(e => {
            return e.map(v => {
              v.colRate = v.col / this.config.colNum
              // 如果一行只有一列，且是下拉框，则默认占用整行
              if (e.length === 1 && v.widgetType && (v.widgetType === 'select' || v.widgetType === 'select-dic' || v.widgetType === 'select-select')) {
                v.colRate = 1
              }
              return v
            })
          })
        }

        // console.info('------this.readOnly----'+this.readOnly);
        // console.info(topButtons);
        let standardButtons = []
        /* 2021-02-24 14:24 update by Blueeyedboy
          去掉了  && (!this.singleSelect && !this.multipleSelect) 条件
          因为只需要通过readOnly就可以控制是否只读，弹框的时候只需要传参readOnly即可
         */
        if (!ifNewBtn && this.config.btnAdd == 1 && !this.readOnly) {
          // console.info('--------------')
          // 添加默认新增按钮 排除导入多个明细表
          standardButtons.push({columnName: 'new', title: '新增', icon: 'el-icon-plus'})
          // topButtons = topButtons.splice(0,0,{columnName:'new',title:'新增',icon:'el-icon-plus'});
        }
        // 添加导入按钮,
        if (this.config.formExcelList && this.config.formExcelList.length > 0 && this.config.formExcelList[0].category !== 3) {
          topButtons.push({
            icon: 'el-icon-download',
            title: '导入',
            widgetType: 'import',
            data: this.config.formExcelList
          })
        }
        if (!ifImportBtn && !this.readOnly && (!this.singleSelect && !this.multipleSelect)) {
          // 添加默认导入按钮
          // topButtons = topButtons.splice(0,0,{columnName:'new',title:'导入',icon:'el-icon-download'});
          // standardButtons.push({columnName:'import',title:'导入',icon:'el-icon-download'});
        }
        if (!ifExportBtn && this.config.btnExport == 1 && !this.isTree) {
          // topButtons = topButtons.splice(0,1,{columnName:'new',title:'导出',icon:'el-icon-upload2'});
          standardButtons.push({columnName: 'export', title: '导出', icon: 'el-icon-upload2'})
        }
        if (standardButtons.length > 0) {
          standardButtons.reverse().forEach(button => {
            topButtons.unshift(button)
          })
        }
        if (searchFormRows.length > 0) {
          // console.log('------formData------',formData)
          _this.formData = formData
          _this.searchFormColumns = searchFormColumns
          _this.searchFormRows = searchFormRows
        }
        // 过滤权限
        gridColumns = gridColumns.filter((item, index) => {
          return item.btnLook == 1
        })

        this.gridColumns = JSON.parse(JSON.stringify(gridColumns))
        this.moreColumns = this.handMoreColumns(JSON.parse(JSON.stringify(gridColumns)))
        this.queryFormVisible = true
        if (searchPlaceholder.length > 0) {
          let laceholder = '请输入'
          for (let i = 0; i < searchPlaceholder.length; i++) {
            if (i !== searchPlaceholder.length - 2) {
              laceholder += searchPlaceholder[i] + '、'
            } else {
              laceholder += searchPlaceholder[i] + '或'
            }
          }
          this.searchPlaceholder = laceholder.slice(0, laceholder.length - 1)
        }
        this.searchVisible = searchVisible
        var vue = Vue // 定义Vue eval里无法直接获取vue
        eval("vue.prototype['copyForm'] = function (params){this.$confirm('是否确认复制'+params.TITLE_+'表单?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => { this.copy(params.FORM_KEY_).then(res => {if(res.status === 200){this.loadData();this.$message({type: 'success',message: '复制成功!'});}}); }).catch(() => {this.$message({type: 'info',message: '已取消复制'});});}")
        eval("vue.prototype['syncForm'] = function (params){this.$confirm('是否确认同步'+params.TITLE_+'表单?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => { this.sync(params.FORM_KEY_).then(res => {if(res.status === 200){this.loadData();this.$message({type: 'success',message: '同步成功!'});}}); }).catch(() => {this.$message({type: 'info',message: '已取消同步'});});}")
        this.summaryColumns = summaryColumns
        if (summaryColumns !== null) {
          this.summaryColumns = summaryColumns
          this.showSummary = true
          this.$forceUpdate()
        }
        // console.log('------gridColumns----',_this.gridColumns,this.showSummary,this.summaryColumns)
        // 加载table数据
        // 添加延时加载 解决数据字典未加载完数据导致显示不正确bug
        setTimeout(() => {
          if (this.autoLoad) {
            this.loadData()
          }
        }, 200)
        this.formConfig = {...this.config}
        // console.info(topButtons);
        // 传递到query-form
        this.topButtons = topButtons
        // 把当前组件传递给子组件
        this.formConfig.parent = this
      }
    },
    getConstValue (key) { // 根据key获取常量值
      // console.info(column)
      if (key === 'current-user-uid' || key === '当前用户主键') {
        return this.sessionUtil.getUserUid()
      } else if (key === 'current-user-id' || key === '当前用户编码') {
        return this.sessionUtil.getUserId()
      } else if (key === 'current-user-name' || key === '当前用户名称') {
        return this.sessionUtil.getUserName()
      } else if (key === 'current-depart-uid' || key === '当前部门主键') {
        return this.sessionUtil.getDepartUid()
      } else if (key === 'current-depart-id' || key === '当前部门编码') {
        return this.sessionUtil.getDepartId()
      } else if (key === 'current-depart-name' || key === '当前部门名称') {
        return this.sessionUtil.getDepartName()
      } else if (key === 'current-company-uid' || key === '当前组织主键') {
        return this.sessionUtil.getDepartUid()
      } else if (key === 'current-company-id' || key === '当前组织编码') {
        return this.sessionUtil.getDepartId()
      } else if (key === 'current-company-name' || key === '当前组织名称') {
        return this.sessionUtil.getDepartName()
      } else if (key === 'current-date' || key === '当前日期') {
        return (new Date()).format('yyyy-MM-dd')
        // mainData[column.columnName] = new Date()
      } else if (key === 'current-datetime' || key === '当前日期时间') {
        return new Date()
        // mainData[column.columnName] = (new Date()).format("yyyy-MM-dd hh:mm:ss")
      } else if (key === 'current-year' || key === '当前年' || key === '本月') {
        return new Date().getFullYear()
      } else if (key === 'current-month' || key === '当前月' || key === '本月') {
        return new Date().getMonth() + 1
      } else if (key === 'current-month-long') {
        let s = new Date().getMonth() + 1;
        return this.util.numPadStart(s,2);
      } else if (key === 'current-week' || key === '当前周' || key === '本周') {
        return this.util.getYearWeek()
      } else if (key === 'current-next-monday' || key === '下周一') { // 下周一
        return this.util.getNextMonday()
      } else if (key === 'current-month-first' || key === '本月第一天') { // 本月第一天
        return this.util.getCurrentMonthFirst()
      } else if (key === 'current-month-last' || key === '本月最后一天') { // 本月最后一天
        return this.util.getCurrentMonthLast()
      } else if (key === 'next-month-first' || key === '下月第一天') { // 下月第一天
        return this.util.getNextMonthFirst()
      } else if (key === 'next-month-last' || key === '下月最后一天') { // 下月最后一天
        return this.util.getNextMonthLast()
      } else {
        var sessionProj = this.sessionUtil.getProjInfo(this)

        if (sessionProj) {
          sessionProj = {
            'session-proj-code': sessionProj.PROJ_CODE_,
            'session-proj-id': sessionProj.PROJ_ID_,
            'session-proj-name': sessionProj.PROJ_NAME_,
            'session-proj-uid': sessionProj.PROJ_UID_
          }
          for (const edit in sessionProj) {
            if (key.indexOf(edit) > -1) {
              key = key.replace(new RegExp('{' + edit + '}', 'gm'), sessionProj[edit])
            }
          }
        }
        // 如果是占位符且没有匹配到参数
        if (key.indexOf('{') > -1) {
          return ''
        }
        return key
      }
    },
    handleBeforeUpload (file) {
      this.readFile(file)
    },
    // 读取文件
    readFile (file) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onloadstart = e => {
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
      }
      reader.onprogress = e => {
        this.progressPercent = Math.round(e.loaded / e.total * 100)
      }
      reader.onerror = e => {
        this.util.error('文件读取出错')
      }
      reader.onload = e => {
        this.util.success('文件读取成功')
        const data = e.target.result
        const { header, results } = excel.read(data, 'array')[0]
        this.excelData = results
        this.uploadLoading = false
      }
    },
    handleUploadFile () {
      this.file = null
    },
    // 处理生成多表头格式
    handMoreColumns (fields) {
      // 处理多表头
      let fieldsmap = []
      // 遍历所有字段组织多表头的数据位
      for (let i = 0; i < fields.length; i++) {
        let title = fields[i].title
        if (title.indexOf('-') > -1) {
          let titles = title.split('-')
          let length = titles.length
          let j = length
          if (fieldsmap.find(event => { return event.title === titles[0] })) {
            let temp = fieldsmap.find(event => { return event.title === titles[0] })
            let k = 1
            for (k = 1; k < length - 1; k++) {
              if (temp.children.find(event => { return event.title === titles[k] })) {
                temp = temp.children.find(event => { return event.title === titles[k] })
              } else {
                for (let m = k; m < length - 1; m++) {
                  if (!temp.children) {
                    temp.children = []
                  }
                  temp.children.push({title: titles[m], children: [] })
                  temp = temp.find(event => { return event.title === titles[m] })
                }
                break
              }
            }
            if (!temp.children) {
              temp.children = []
            }
            fields[i].title = titles[length - 1]
            temp.children.push(fields[i])
          } else {
            fieldsmap.push({title: titles[0], children: [] })
            let temp = fieldsmap.find(event => { return event.title === titles[0] })
            for (let k = 1; k < length - 1; k++) {
              if (!temp.children) {
                temp.children = []
              }
              temp.children.push({title: titles[k], children: [] })
              temp = temp.children.find(event => { return event.title === titles[k] })
            }
            if (!temp.children) {
              temp.children = []
            }
            fields[i].title = titles[length - 1]
            temp.children.push(fields[i])
          }
        } else {
          fieldsmap.push(fields[i])
        }
      }
      return fieldsmap
    },
    handlerParentClick (row) { // 监听级联页面时，上一个关联父页面点击触发本页面数据刷新
      this.pageIndex = 1
      this.parentSelectedRow = row
      // 左右结构点击左侧清空keyWord模糊查询条件
      this.keyword = ''
      // console.log('--------handlerParentClick--------',row,this.config)
      this.rootId = null
      if(this.validUtil.isNotNull(this.config.rootId)){
        let rootIdVal = this.config.rootId
        if(rootIdVal.indexOf('{')>-1){
          rootIdVal = this.util.replaceStr(rootIdVal, row)
        }
        this.rootId = rootIdVal
      }
      this.loadData()
    },
    downloadExecl (edit) {
      this.excelModal = edit
    },
    computeInitValue (key) { // 表单新增初始化计算初始值
      // console.info(column)
      if (key === '{current-user-uid}') {
        return this.sessionUtil.getUserUid()
      } else if (key === '{current-user-id}') {
        return this.sessionUtil.getUserId()
      } else if (key === '{current-user-name}') {
        return this.sessionUtil.getUserName()
      } else if (key === '{current-depart-uid}') {
        return this.sessionUtil.getDepartUid()
      } else if (key === '{current-depart-id}') {
        return this.sessionUtil.getDepartId()
      } else if (key === '{current-depart-name}') {
        return this.sessionUtil.getDepartName()
      } else if (key === '{current-company-uid}') {
        return this.sessionUtil.getDepartUid()
      } else if (key === '{current-company-id}') {
        return this.sessionUtil.getDepartId()
      } else if (key === '{current-company-name}') {
        return this.sessionUtil.getDepartName()
      } else if (key === '{current-date}') {
        return (new Date()).format('yyyy-MM-dd')
      } else if (key === '{current-datetime}') {
        return (new Date()).format('yyyy-MM-dd hh:mm:ss')
      } else if (key === '{current-year}') {
        return new Date().getFullYear()
      } else if (key === '{current-month}') {
        return new Date().getMonth() + 1
      } else if (key === '{current-week}') {
        return this.util.getYearWeek()
      } else if (key === '{current-next-monday}') { // 下周一
        return this.util.getNextMonday()
      } else if (key === '{current-month-first}') { // 本月第一天
        return this.util.getCurrentMonthFirst()
      } else if (key === '{current-month-last}') { // 本月最后一天
        return this.util.getCurrentMonthLast()
      } else if (key === '{next-month-first}') { // 本月第一天
        return this.util.getNextMonthFirst()
      } else if (key === '{next-month-last}') { // 本月最后一天
        return this.util.getNextMonthLast()
      } else {
        return null
      }
      // console.log(column.columnName+'-----------'+mainData[column.columnName])
    },
    selectExcel () {
      let modal = {}
      if (this.excelModal) {
        modal = this.excelModal
      } else {
        modal = this.excelList[0]
      }
      console.log("selectExcel===新===>",modal)
      console.log("selectExcel===新===>",this.excelData)
      if (modal && modal.children && modal.children.length > 0 && this.excelData && modal.category && modal.category === 2) {
        if (this.gridData === undefined) {
          this.gridData = []
        }
        let data = []
        // 导入添加排序
        let sort = this.totalCount
        //console.log('------this.excelData-----',this.excelData)
        this.excelData.forEach(item => {
          let row = { SORT_: sort++ }
          modal.children.forEach(column => {
            if (column.excelName) {
              // 将key值转换为小写
              column.columnName = column.columnName.toLowerCase()
              //console.log(column.columnName+'--------'+column.excelName+'-------',(typeof item[column.excelName]),item[column.excelName])
              let v = item[column.excelName];
              if(typeof v === 'object'){
                try{
                  var d=new Date(v);
                  v = d.format("yyyy-MM-dd");
                  row[column.columnName] = v;
                }catch(e){
                  row[column.columnName] = v;
                }
              }else{
                row[column.columnName] = v;
              }

              // 固定常量
              if (column.excelName.startsWith('[') && column.excelName.endsWith(']')) {
                row[column.columnName] = column.excelName.slice(1, column.excelName.length).slice(0, column.excelName.length - 1)
              }
              // 系统参数
              if (column.excelName.indexOf('{') > -1) {
                let searchParams = this.$refs['query-form'].getParams()
                // 搜索条件
                for (const key in searchParams) {
                  row[column.columnName] = column.excelName.replace(new RegExp('{' + key + '}', 'gm'), searchParams[key])
                }
                // 全局项目
                let sessionProj = {}
                if (window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id)) {
                  sessionProj = JSON.parse(window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id))
                } else if (this.getFormConfig && this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id]) {
                  sessionProj = this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id].data
                }
                if (sessionProj) {
                  for (const key in sessionProj) {
                    row[column.columnName] = column.excelName.replace(new RegExp('{' + key + '}', 'gm'), sessionProj[key])
                  }
                }
                // 父级页面携带参数
                if (this.parentSelectedRow) {
                  for (const key in this.parentSelectedRow) {
                    if (column.excelName.indexOf(key) > -1) {
                      row[column.columnName] = column.excelName.replace(new RegExp('{' + key + '}', 'gm'), this.parentSelectedRow[key])
                    }
                  }
                }
                // 其他系统常量
                let computeInitValue = this.computeInitValue(column.excelName)
                if (computeInitValue) {
                  row[column.columnName] = computeInitValue
                }
              }
            }
          })
          data.push(row)
        })
        //console.log('---selectExcel---data----',data)
        //return;
        let params = {
          formKey: this.config.formKey,
          formId: modal.formId,
          formInfoId: modal.formInfoId,
          data: data,
          tableName: this.config.tableName,
          errorMechanism: modal.errorMechanism
        }
        if(data.length== 0){
          this.util.warn('解析的数据为空，请检查！')
          return ;
        }
        // 如果没配置api 走默认api地址
        if (!modal.api) {
          modal.api = '/api_v1/excel/common'
        }
        console.log(`api地址：` + modal.api + `参数：`, params)
        this.util.mask('正在导入！')
        this.util.restPost(modal.api, params, res => {
          if (res.status === 200) {
            this.util.success('导入成功!')
            let insertCount = 0
            let errorCount = 0
            let data = res.data
            if (data && data.insertData && data.insertData.length > 0) {
              insertCount = data.insertData.length
            }
            if (data && data.errorData && data.errorData.length > 0) {
              errorCount = data.errorData.length
              this.errorData = data.errorData
            }
            this.insertCount = insertCount
            this.errorCount = errorCount
            this.resultVisible = true
          } else {
            this.util.warn('导入失败!' + data.errorMsg)
          }
          this.util.unmask()
          this.loadData()
        })
      } else {
        if(modal.category && modal.category === 1){
          this.util.warn('必须配置后端导入！')
          return
        }
        this.util.warn('导入配置错误！请重新配置！')
      }
    },
    handleSizeChange (pageSize) { // pageSize切换
      this.pageIndex = 1
      this.pageSize = pageSize
      this.loadData()
    },
    handleCurrentChange (pageIndex) { // pageSize切换
      // console.info(this)
      let pageCount = this.pageCount
      if (pageIndex <= pageCount) {
        this.pageIndex = pageIndex
        this.loadData()
      }
    },
    queryData (params) { // 查询表单查询调用
      let parentWhere = this.config.parentWhere;
      // 判断是否拼接，默认不拼接
      if(parentWhere && parentWhere == 1){

      }else{
        // 如果是点击查询按钮 清空this.parentSelectedRow
        this.parentSelectedRow = null
      }

      if (params) {
        this.keyword = params.keyword
        this.formData = params.formData
        this.pageIndex = 1;
        this.loadData()
      }
    },
    openReport (params) {
      params.gridParams = this.getParams()
      if (params.exportAll) {
        params.gridParams.pageSize = 2147483647
      }
      // params.gridParams.pageSize = 2147483647
      this.$router.push({
        name: 'page-html5',
        params: params
      })
    },
    // 树表懒加载
    load (tree, treeNode, resolve) {
      this.rootId = tree.id
      this.loadData(resolve)
    },
    getParams () {
      let config = this.config
      let searchParams = []
      // 判断是否带有过滤参数
      let queryParams = []
      let queryParam = this.queryParams
      // 存储所有的唯一参数,避免出现重复参数
      let queryParamMap = {}
      //console.log('------getParams------',this.parentSelectedRow,queryParams,queryParam)
      if (queryParam) {
        // 把url传参或者父组件传参传递到后台
        for (let key in queryParam) {
          // console.log(key+'-------------'+queryParam[key])
          if (this.validUtil.isNotNull(queryParam[key])) {
            queryParams.push({'key': key, 'value': queryParam[key]})
            queryParamMap[key] = queryParam[key]
          } else {
            // 如果左侧选中行中有该值，则替换
            if (this.parentSelectedRow != null && this.parentSelectedRow[key] !== undefined) {
              queryParams.push({'key': key, 'value': this.parentSelectedRow[key]})
              queryParamMap[key] = this.parentSelectedRow[key]
            } else {
              queryParams.push({'key': key, 'value': queryParam[key]})
              queryParamMap[key] = queryParam[key]
            }
          }
        }
      }
      // console.log('------getParams---2---',queryParams,queryParam)
      // 判断是否搜索,然后拼接搜索
      let formData = this.formData
      if (formData) {
        this.config.queryColumns.forEach(column => {
          let val = formData[column.columnName]
          if (val && this.validUtil.isNotNull(val) && column.matchType != undefined) {
            searchParams.push(
              {
                'key': column.columnName,
                'value': val
              }
            )
          }else{
            // console.log(column.columnName+'-----column.columnNam------',column,val,queryParam)
            // 判断是否高级查询
            /*if(this.validUtil.isNotNull(column.matchType) && this.validUtil.isNotNull(column.row)&& this.validUtil.isNotNull(column.col)){
              // 判断是否客户没有选择设置高级查询条件值
              if(this.validUtil.isNull(val)){
                // 判断如果组件传参queryParams有值，则替换
                val = queryParam[column.columnName]
                if(queryParam && this.validUtil.isNotNull(val)){
                  searchParams.push(
                    {
                      'key': column.columnName,
                      'value': val
                    }
                  )
                }
              }
            }*/
          }
        })
      }
      // console.log('------getParams---3---',queryParams,queryParam)
      let parentId = null
      if (this.parentSelectedRow != null) {
        parentId = this.parentSelectedRow.id || this.parentSelectedRow.ID_
        // 把左右结构或者上下结构前一个选中行整个传参
        for (let key in this.parentSelectedRow) {
          if (key !== 'id' && key != 'ID_' && key != 'children') {
            if (this.validUtil.isNull(queryParam[key])) {
              queryParams.push({'key': key, 'value': this.parentSelectedRow[key]})
              queryParamMap[key] = this.parentSelectedRow[key]
            }
          }
        }
      }
      // console.log('------getParams---4---',queryParams,queryParam)
      let params = {
        'formKey': config.formKey,
        'id': config.id,
        'keyword': this.keyword,
        'pageIndex': this.pageIndex,
        'pageSize': this.pageSize,
        'searchParams': searchParams,
        'queryParams': queryParams,
        'parentId': parentId
      }
      //console.log('------getParams---5---',this.parentSelectedRow,parentId,queryParams,queryParam)
      let apiConfig = this.config.apiConfig
      // console.log('-------getParams-----apiConfig---',queryParams,params,apiConfig,this.parentSelectedRow)
      // console.info(queryParams)
      if (apiConfig) {
        if (apiConfig.children) {
          apiConfig.children.forEach(child => {
            let key = null
            if (child.value && child.value.indexOf('{') > -1) {
              key = child.value.substring(child.value.indexOf('{') + 1, child.value.indexOf('}')).trim()
            }
            if (key != null && queryParamMap && queryParamMap[key] !== undefined) {
              // 判断queryParams或者this.parentSelectedRow是否已经设置过参数，如果设置过则不需要再设置
              // queryParams.push({'key': child.code, 'value': queryParam[key]})
            } else {
              // 如果左侧选中行中有该值，则替换
              if (this.parentSelectedRow != null && this.parentSelectedRow[key] !== undefined) {
                queryParams.push({'key': child.code, 'value': this.parentSelectedRow[key]})
              } else {
                if (child.value && child.value.indexOf('{') > -1) {

                }else{
                  queryParams.push({'key': child.code, 'value': child.value})
                }

              }
            }
          })
        }
        params.apiId = apiConfig.id
        if (apiConfig.runtype === 'Interface') {
          params._url = apiConfig.runsql
        }
      }
      // console.log('-------getParams-----2---',params)
      return params
    },
    loadData (resolve) { // 加载grid数据
      // console.log('-------loadData--------',resolve,this.rootId)
      let _this = this
      _this.emptyText = '正在加载...'
      if (this.config.lazy === undefined || this.config.lazy === 0) {
        this.loading = true
      }
      let params = this.getParams()
      // 每次刷新都清空selection
      // this.$refs['jr-table'].clearSelection()
      let oldSelectedData = _this.getSelectedData(0)
      this.selection = []
      if (this.isTree) {
        // 说明是懒加载
        if(resolve){
        }else{
          // 说明是刷新重新加载
          this.rootId = null
          if(this.validUtil.isNotNull(this.config.rootId)){
            let rootIdVal = this.config.rootId
            if(rootIdVal.indexOf('{')>-1){
              rootIdVal = this.util.replaceStr(rootIdVal, this.parentSelectedRow)
            }
            this.rootId = rootIdVal
          }
        }
        params.rootId = this.rootId
        getTreeData(params, this).then(data => {
          // console.log('--------getTreeData---------',_this.$refs['jr-table'].store.states,data,_this.config.showRoot, this.rootId)
          if (data && data.length > 0) {
            // 递归组装数据
            _this.deepPackSummary(data);
            // 添加跟节点显示
            if (_this.config.showRoot && !this.rootId) {
              let root = {}
              root['children'] = data
              root['id'] = _this.config.rootId
              root[_this.config.treeColumn] = _this.config.rootText
              _this.rowClick(root)
              data = [root]
            }
            // 判断是否有自定义的渲染数据的方法

            var jsCode = this.config.jsCode;
            if(_this.validUtil.isNotNull(jsCode)) {
              var beforeGridRenderData = undefined;
              //var test = undefined;
              //var testStr = 'test = function(data,vm){console.log(data,vm);alert(1);}';
              //eval(testStr);
              // test();
              //let result = test(form.config.tableData,_this);
              // console.log('=============',jsCode);
              eval(jsCode);
              if (beforeGridRenderData) {
                data = beforeGridRenderData(data, this.config, _this);
              }
            }

            if (resolve) {
              setTimeout(() => {
                resolve(data)
              }, 1000)
            } else {
              _this.gridData = data
              // _this.$set(_this.$refs['jr-table'].store.states.lazyTreeNodeMap,params.rootId,data)
              // 因为vue会根据id缓存组件，避免无法刷新需要手动设置如下数据
              const { lazyTreeNodeMap, treeData } = this.$refs['jr-table'].store.states;
              for(let key in treeData){
                treeData[key].loaded = false;
                treeData[key].expanded = false;
              }
              // _this.$forceUpdate()
              // this.$refs['jr-table'].store.updateTreeData()
              // console.log('-------1--------',this.$refs['jr-table'])

              // 如果为左右结构 且为左侧 默认将第一行数据作为参数


              let defaultSelectedRow = undefined;
              // 设置默认选中行，如果之前有选中过，则优先历史的选中行
              if (_this.config.parent && _this.isLeft) {
                defaultSelectedRow = _this.gridData[0]
              }
               //console.log(defaultSelectedRow,'------oldSelectedData------',oldSelectedData)
              if(oldSelectedData && oldSelectedData.length === 1){
                let oldSelectedRow = oldSelectedData[0]
                if(oldSelectedRow['ID_']){
                  // 查找对应的数据
                  let find = _this.util.findTreeNode(_this.gridData,'ID_',oldSelectedRow['ID_']);
                  if(find){
                    defaultSelectedRow = find
                  }
                  //console.log(defaultSelectedRow,'------oldSelectedData---find---',oldSelectedData)
                }
              }

              _this.$nextTick(()=>{
                if(defaultSelectedRow){
                  _this.$refs['jr-table'].setCurrentRow(defaultSelectedRow);// 用于单选
                  _this.handlerSelectionChange([defaultSelectedRow]);
                  _this.config.parent.handlerRowClick(2, defaultSelectedRow);
                }
              });
            }
          } else {
            if (resolve) return resolve([])
            _this.emptyText = '暂无数据'
            _this.pageCount = 0
            _this.gridData = []
          }
          this.handlerSelectionAutoSet()// 自动把之前选择数据勾选上
          this.loading = false
        })
      } else {
        getGridData(params, this).then(res => {
          // console.log('----------getGridData---------')
          // 组装合并行数据
          _this.computeRowSpan(res.data)
          _this.gridData = res.data
          // console.log('--------res.data---------',res.data,_this.gridData)
          if (res.data == undefined || res.data.length === 0) {
            _this.emptyText = '暂无数据'
            _this.pageCount = 0
            _this.totalCount = 0
          } else {
            _this.totalCount = res.totalCount
            // 如果为左右结构 且为左侧 默认将第一行数据作为参数
            if (_this.config.parent && _this.isLeft) {
              // 设置默认选中行，如果之前有选中过，则优先历史的选中行
              let defaultSelectedRow = _this.gridData[0]
              // console.log(defaultSelectedRow,'------oldSelectedData------',oldSelectedData)
              if(oldSelectedData && oldSelectedData.length === 1){
                let oldSelectedRow = oldSelectedData[0]
                if(oldSelectedRow['ID_']){
                  // 查找对应的数据
                  let find = _this.gridData.find(item => {
                    return item['ID_'] === oldSelectedRow['ID_']
                  })
                  if(find){
                    defaultSelectedRow = find
                  }
                  // console.log(defaultSelectedRow,'------oldSelectedData---find---',oldSelectedData)
                }
              }

              this.$refs['jr-table'].setCurrentRow(defaultSelectedRow)// 用于单选
              this.handlerSelectionChange([defaultSelectedRow])
              _this.config.parent.handlerRowClick(2, defaultSelectedRow)
            }
            _this.pageCount = (_this.totalCount + _this.pageSize - 1) / _this.pageSize
            // this.handlerDeepSetChecked(_this.gridData)
          }
          this.handlerSelectionAutoSet()// 自动把之前选择数据勾选上
          this.loading = false
        }).catch(() => {
          // console.info('---------catch---------')
          _this.emptyText = '暂无数据'
          _this.pageCount = 0
          _this.totalCount = 0
          this.handlerSelectionAutoSet()// 自动把之前选择数据勾选上
          this.loading = false
        })
      }
    },
    // 刷新级联父页面
    loadParentData () {
      this.$emit('loadParentData')
    },
    copy (params) {
      return copy(params)
    },
    // 同步表单
    sync (params) {
      return sync(params)
    },
    handleReserve (row) {
      return row.ID_
    },
    handlerRowClick (queryFormIndex, row) { // 监听查询列表的单击事件
      // console.info('------handlerRowClick-------' + queryFormIndex)
      // console.info(row)
    },
    toggleRowExpansion (row, expanded) {
      console.log(row, expanded)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
      // console.log('------this.rowSpanData----',this.rowSpanData)
      let columnName = column.property
      if (columnName && this.rowSpanData[columnName]) {
        if (this.rowSpanData[columnName][rowIndex]) {
          return {
            rowspan: this.rowSpanData[columnName][rowIndex],
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    computeRowSpan(data){ // 计算行合并
      let rowSpanData = {}
      let preValueData =  {}
      let preCountData = {}
      let preIndexData = {}
      if(this.rowSpanColumns.length>0 && data){
        data.forEach((item,index)=>{
          // debugger
          this.rowSpanColumns.forEach(column => {
            let columnName = column.columnName
            let widgetType = column.widgetType
            if(!rowSpanData[columnName]){
              rowSpanData[columnName] = {}
              preValueData[columnName] = null
              preCountData[columnName] = 0
              preIndexData[columnName] = index
            }
            let preValue = preValueData[columnName]
            let preCount = preCountData[columnName]
            let value = item[columnName]
            if(widgetType && widgetType == 'select-date'){
              value = this.util.formatDate(column,value);
            }

            // 判断是第一行
            if(index === 0){
              preValueData[columnName] = value
              preCountData[columnName] = 1
              preIndexData[columnName] = index
              // 避免只有一行的问题
              rowSpanData[columnName][preIndexData[columnName]] = 1
            }else{
              // 判断是否相同
              if(value === preValue){
                preCountData[columnName] = preCountData[columnName] + 1
                rowSpanData[columnName][preIndexData[columnName]] = preCountData[columnName]
              }else{
                // 说明数据不一样，需要另取一行
                preIndexData[columnName] = index
                preValueData[columnName] = value
                preCountData[columnName] = 1
                rowSpanData[columnName][preIndexData[columnName]] = 1
              }
            }
          })
        })
      }
      this.rowSpanData = rowSpanData
      // console.log('-----computeRowSpan-----',rowSpanData,rowSpanData.length)

    }
  }
}



// WEBPACK FOOTER //
// ./src/common/form/grid-tree-table/mixin.js